module.exports = __webpack_public_path__ + "static/media/id-card.636faebd.svg";